import cssVariables from 'tfs.css-variables'

export default {
  button: {
    padding: '0.5rem 1.7rem',
    borderRadius: '1.25rem',
    backgroundColor: cssVariables.colorRuby,
    color: cssVariables.colorRubyTypography,
    border: 'none',
    cursor: 'pointer',
    boxShadow: 'inset 0 -0.125rem 0.25rem 0 rgba(0,0,0,.2)',
    fontSize: '1rem',
    fontWeight: 'bold',
    transition: 'background-color .2s',
    whiteSpace: 'nowrap',
    outline: 'none',

    '&:hover, &:active, &:focus': {
      backgroundColor: cssVariables.colorRubyHover,
    },
  },
  colorGreen: {
    backgroundColor: cssVariables.colorGreen,
    color: cssVariables.colorGreenTypography,

    '&:hover, &:active, &:focus': {
      backgroundColor: cssVariables.colorGreenHover,
    },
  },
  colorBlue: {
    backgroundColor: cssVariables.colorBlue,
    color: cssVariables.colorBlueTypography,

    '&:hover, &:active, &:focus': {
      backgroundColor: cssVariables.colorBlueHover,
    },
  },
  colorWhite: {
    backgroundColor: cssVariables.colorWhite,
    borderColor: cssVariables.colorWhiteBorder,
    color: cssVariables.colorGrayA,
    boxShadow: `inset 0 -3px 2px 0 ${cssVariables.colorWhiteBorder}`,
    borderRadius: '0.5rem',
    border: `1px solid ${cssVariables.colorWhiteBorder}`,

    '&:hover, &:active, &:focus': {
      backgroundColor: cssVariables.colorWhiteHover,
    },
  },
  disabled: {
    backgroundColor: cssVariables.colorGrayE,
    color: cssVariables.colorGrayC,
    boxShadow: 'none',
    '&:hover, &:active, &:focus': {
      backgroundColor: cssVariables.colorGrayC,
      cursor: 'default',
    },
  },
  colorTransparent: {
    backgroundColor: 'transparent',
    borderRadius: 0,
    border: 'none',
    padding: 0,
    color: cssVariables.colorGrayA,
    boxShadow: 'none',
    fontWeight: 'normal',

    '&:hover, &:active, &:focus': {
      backgroundColor: 'transparent',
    },
  },
  children: {
    display: 'inline-block',
  },
  icon: {
    textShadow: '0 0.125rem 0.125rem rgba(0,0,0,0.2)',
    marginRight: '0.7rem',
  },
  iconRight: {
    marginRight: 0,
    marginLeft: '0.7rem',
    float: 'right',
  },
}
